import { useRef } from "react";
import { formatDate } from "../../helpers/formatDate";
import { getCurrentDate } from "../../helpers/getCurrentDate";
import styles from "./styles";
import { localStorageData } from "../../helpers/utils";
import ReactLogo from '../../assets/images/salonbill1.png'

const ClientJobCard = ({ data, selectGlobalOrg, userData }) => {

  const loopItrate = new Array(15).fill(null);

  const isFirstRender = useRef(true);

  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const CLEAN_BASE_URL = BASE_URL.replace(/\/api\/?$/, "");
  const storedOrgId = localStorageData.get('organisation'); // Retrieve stored org ID
  const userOrganizations = userData?.get_orgnaisation || [];

  // Find the matching organization if storedOrgId exists, else pick the first organization
  const matchedOrg = storedOrgId
    ? userOrganizations.find(org => org.organisation_id == storedOrgId)
    : userOrganizations[0];

  // Logo Source (fallback to default logo if no logo is found)
  // const logoSrc = matchedOrg?.organisation?.logo
  //   ? `${CLEAN_BASE_URL}/storage/${matchedOrg.organisation.logo}`
  //   : ReactLogo;

  const logoSrc = matchedOrg?.organisation?.logo
    ? `${CLEAN_BASE_URL.replace("http://", "https://")}/storage/${matchedOrg.organisation.logo}`
    : ReactLogo;

  // Organization Name (fallback to "Unknown Organisation")
  const organisationName = matchedOrg?.organisation?.name || "Unknown Organisation";



  const date = getCurrentDate();

  // console.log(date,'date');

  return (

    <>

      <div className="invoice" style={styles.invoice}>
        <img
          src={logoSrc}
          alt="Organization Logo"
          style={{ width: "100%", height: "auto", maxHeight: "80px", objectFit: "contain" }}
        />

        <table style={styles.width}>
          <tr>
            <td>
              <table style={styles.width}>
                <tr>
                  <td style={styles.textCenter}> <h1 className="heading" style={styles.heading}>{data?.get_org_info?.name ?? organisationName}</h1></td>
                </tr>
              </table>
            </td>
          </tr>
          <tr>
            <td className="borderb" style={{ ...styles.paddingt, ...styles.paddingb }}>
              <table style={styles.width}>
                <tr>
                  <td style={{ width: '60%' }}>
                    <p className="billno" style={styles.billno}>Client Name: {data.get_customer_info?.name}</p>
                  </td>
                  <td style={{ width: '40%' }}>
                    <p className="billno" style={styles.billno}>Bill No: {data.get_customer_info?.name}</p>
                  </td>
                </tr>
              </table>
              <table style={styles.width}>
                <tr>
                  <td style={{ width: '60%' }}>
                    <p className="billno" style={styles.billno}>Ph No: {data.get_customer_info?.phone_number}</p>
                  </td>
                  <td style={{ width: '40%' }}>
                    <p className="billno" style={styles.billno}>Date: {formatDate(data.created_at)}</p>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
          <tr>
            <td>
              <table className="invoice-table" style={styles.width}>
                <thead className="theadbg" style={styles.theadbg}>
                  <tr>
                    <th className="theadth" style={{ width: "50%", ...styles.theadth, ...styles.textLeft }}>Service</th>
                    <th className="theadth" style={{ width: "50%", ...styles.theadth, ...styles.textLeft }}>Staff</th>
                  </tr>
                </thead>
                <tbody>

                  {data?.get_multiple_services?.map((item, index) => (
                    <tr key={index} className="" style={styles.borderb}>
                      <td className="theadtd" style={{ width: "50%", height: "25px", ...styles.theadtd, ...styles.textLeft }}>{item?.get_service_name?.name || ''}</td>
                      <td className="theadtd" style={{ width: "50%", height: "25px", ...styles.theadtd, ...styles.textLeft }}>{item?.get_staff_name?.name}</td>

                    </tr>
                  ))}
                </tbody>
              </table>
              <table style={styles.width}>
                <tr>
                  <td style={{ ...styles.theadth }}>
                    <p>I am fully setisfied with the service offered to me and have no complaint what so ever <span>Tress Lounge</span></p>
                  </td>
                  <td style={styles.theadth}></td>
                </tr>
              </table>
              <table style={styles.width}>
                <tr>
                  <td style={{ width: '50%', textAlign: 'left', ...styles.theadth }}>
                    <p>Client Sign</p>
                  </td>
                  <td style={styles.theadth}></td>
                </tr>
              </table>
            </td>
          </tr>
        </table>
      </div>


    </>

  );

}

export default ClientJobCard;